import { request } from "../request";
import {request2} from "../request2";
import { InterceptPrefix, checkImageBase } from '../utils';
export const uploadFile = (params, other) => {
  return request({
    method: 'post',
    url: '/file/upload',
    params,
    config: {
      formData: true
    },
    axiosConfig: {
      ...other
    }
  }).then(res => {
    return {
      fileUrl: checkImageBase(res.fileUrl),
      thumbnailUrl: checkImageBase(res.thumbnailUrl)
    }
  })
}

export const deleteFile = ({ path }) => {
  return request({
    method: 'post',
    url: '/file/delete',
    params: {
      path: InterceptPrefix(path)
    }
  })
}

export const downloadFileApi = ({ url }) => {
  return request({
    method: 'post',
    url: '/file/download',
    params: {
      url
    },
    axiosConfig: {
      responseType: 'blob',
      pass: true
    }
  })
}
export const pannelFileUpload = (params,id,other) => {
	return request2({
		method: 'post',
		url: `/dashboard/file/upload/${id}`,
		params,
		config: {
			formData: true
		},
    axiosConfig: {
      ...other
    }
	})
}